import React from "react";

function BackArrow() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1392_6383)">
        <path
          d="M4.61902 8.78602L8.39452 12.6637C8.54863 12.822 8.6226 13.0067 8.61643 13.2177C8.61027 13.4287 8.52988 13.6134 8.37526 13.7717C8.22116 13.9167 8.04137 13.9927 7.8359 13.9996C7.63043 14.0064 7.45065 13.9305 7.29655 13.7717L2.21117 8.5486C2.13412 8.46947 2.07941 8.38374 2.04705 8.29141C2.01469 8.19908 1.99902 8.10016 2.00005 7.99464C2.00107 7.88913 2.01726 7.79021 2.04859 7.69788C2.07992 7.60555 2.13437 7.51982 2.21194 7.44068L7.29732 2.21763C7.43858 2.07254 7.61528 2 7.82743 2C8.03958 2 8.22244 2.07254 8.37603 2.21763C8.53013 2.3759 8.60719 2.56398 8.60719 2.78188C8.60719 2.99977 8.53013 3.18759 8.37603 3.34533L4.61902 7.20327H13.2295C13.4478 7.20327 13.6309 7.27924 13.7789 7.43119C13.9268 7.58313 14.0005 7.77095 14 7.99464C13.9995 8.21834 13.9255 8.40642 13.7781 8.55889C13.6307 8.71136 13.4478 8.78707 13.2295 8.78602H4.61902Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_1392_6383">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BackArrow;
